import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Education() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-blue-500 to-indigo-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Educational Services</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Quality teaching materials for Cultural and Creative Arts education in Nigeria
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/5c699ee4fb8998b6d1b5de638ab0e6b4.jpg"
                alt="Cultural and Creative Arts Teaching"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">Cultural and Creative Arts Teaching</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                As an experienced educator with a background in Architecture from Ken Saro Wiwa Polytechnic, Gospel Tennyson Jaja provides comprehensive educational support for Cultural and Creative Arts teachers and students across Nigeria.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our educational materials are specifically designed to align with the Nigerian junior secondary school curriculum, ensuring that teachers have the resources they need to deliver effective and engaging lessons.
              </p>
              <div className="bg-blue-50 rounded-xl p-6">
                <h4 className="text-xl font-bold mb-3 text-blue-600">Why Choose Our Educational Materials</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Aligned with Nigerian curriculum standards</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Created by experienced educators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Comprehensive and easy to use</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Regularly updated content</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Affordable pricing for schools and teachers</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Educational Materials We Provide</h2>
            <p className="text-xl text-gray-600">Everything you need for effective teaching</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Lesson Notes */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-file-text-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Lesson Notes</h3>
                  <p className="text-gray-700">Comprehensive lesson plans for Cultural and Creative Arts</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Detailed lesson objectives and outcomes</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Step-by-step teaching instructions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Practical activities and exercises</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Assessment methods and evaluation criteria</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Available for JSS 1, JSS 2, and JSS 3</span>
                </li>
              </ul>
              <div className="bg-blue-50 rounded-lg p-4 mb-4">
                <p className="text-sm text-gray-700 mb-2"><strong>Pricing:</strong></p>
                <p className="text-gray-700">₦5,000 per term | ₦12,000 per year</p>
              </div>
              <Link to="/contact" className="whitespace-nowrap inline-block bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Request Lesson Notes
              </Link>
            </div>

            {/* Question Papers */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-indigo-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-questionnaire-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Test Questions & Examination Papers</h3>
                  <p className="text-gray-700">Ready-to-use assessment materials</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Multiple choice and theory questions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Mid-term and end-of-term examinations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Marking schemes included</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Covers all curriculum topics</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Editable formats available</span>
                </li>
              </ul>
              <div className="bg-indigo-50 rounded-lg p-4 mb-4">
                <p className="text-sm text-gray-700 mb-2"><strong>Pricing:</strong></p>
                <p className="text-gray-700">₦3,000 per test | ₦8,000 per term package</p>
              </div>
              <Link to="/contact" className="whitespace-nowrap inline-block bg-indigo-500 hover:bg-indigo-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Request Question Papers
              </Link>
            </div>

            {/* Scheme of Work */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-calendar-check-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Scheme of Work</h3>
                  <p className="text-gray-700">Structured curriculum planning documents</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Week-by-week curriculum breakdown</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Topic distribution across terms</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Learning objectives for each topic</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Teaching methods and resources</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Aligned with national curriculum</span>
                </li>
              </ul>
              <div className="bg-purple-50 rounded-lg p-4 mb-4">
                <p className="text-sm text-gray-700 mb-2"><strong>Pricing:</strong></p>
                <p className="text-gray-700">₦4,000 per term | ₦10,000 per year</p>
              </div>
              <Link to="/contact" className="whitespace-nowrap inline-block bg-purple-500 hover:bg-purple-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Request Scheme of Work
              </Link>
            </div>

            {/* Educational Support */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-customer-service-2-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Educational Support Services</h3>
                  <p className="text-gray-700">Personalized assistance for teachers and students</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">One-on-one consultation for teachers</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Custom material development</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Curriculum planning assistance</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Student tutoring and mentorship</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Workshop and training sessions</span>
                </li>
              </ul>
              <div className="bg-green-50 rounded-lg p-4 mb-4">
                <p className="text-sm text-gray-700 mb-2"><strong>Pricing:</strong></p>
                <p className="text-gray-700">Custom quotes based on requirements</p>
              </div>
              <Link to="/contact" className="whitespace-nowrap inline-block bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Request Support
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Who We Serve</h2>
            <p className="text-xl text-gray-600">Supporting the educational community</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-4xl text-blue-500"></i>
              </div>
              <h4 className="text-2xl font-bold mb-3">Teachers</h4>
              <p className="text-gray-600">
                Cultural and Creative Arts teachers in junior secondary schools who need quality teaching materials and resources
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-parent-line text-4xl text-purple-500"></i>
              </div>
              <h4 className="text-2xl font-bold mb-3">Parents</h4>
              <p className="text-gray-600">
                Parents looking for supplementary educational materials to support their children's learning at home
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-4xl text-green-500"></i>
              </div>
              <h4 className="text-2xl font-bold mb-3">Schools</h4>
              <p className="text-gray-600">
                Educational institutions seeking comprehensive curriculum materials for their Cultural and Creative Arts programs
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">What Educators Say</h2>
            <p className="text-xl text-gray-600">Feedback from teachers and schools</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  MO
                </div>
                <div>
                  <h5 className="font-bold">Mrs. Oluchi</h5>
                  <p className="text-sm text-gray-600">JSS Teacher, Port Harcourt</p>
                </div>
              </div>
              <div className="flex mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 italic">
                "The lesson notes are comprehensive and well-structured. They've made my teaching so much easier and more effective."
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  PE
                </div>
                <div>
                  <h5 className="font-bold">Mr. Emmanuel</h5>
                  <p className="text-sm text-gray-600">Head of Department</p>
                </div>
              </div>
              <div className="flex mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 italic">
                "Excellent materials that align perfectly with the curriculum. Our entire department now uses these resources."
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  SA
                </div>
                <div>
                  <h5 className="font-bold">Mrs. Adaeze</h5>
                  <p className="text-sm text-gray-600">School Administrator</p>
                </div>
              </div>
              <div className="flex mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 italic">
                "Professional, affordable, and reliable. Gospel has been a tremendous help to our school's arts program."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-500 to-indigo-600">
        <div className="container mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Enhance Your Teaching?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Get access to quality educational materials that make teaching easier and more effective
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap bg-white hover:bg-gray-100 text-blue-600 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
            >
              Request Materials
            </Link>
            <a 
              href="tel:08162117807" 
              className="whitespace-nowrap bg-transparent hover:bg-white/10 text-white border-2 border-white px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer"
            >
              Call: 08162117807
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}